

































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import Loading from "@/components/Loading.vue";

export default Vue.extend({
  components: { Loading },
  data() {
    return {
      loaded: false,
      saving: false,
      successMessage: "",
      errorMessage: "",
      featureConfig: {
        retroactiveCharge: {
          enabled: false,
        },
        applessPayment: {
          enabled: false,
        },
        multiTierPricing: {
          enabled: false,
          slowDisconnectPenaltyEnabled: false,
        },
      },
    };
  },
  async created() {
    try {
      const data = await coreApiClient.call("setting", "get");
      if (data && data.featureConfig) {
        const fc = data.featureConfig;
        if (fc.retroactiveCharge) {
          this.featureConfig.retroactiveCharge.enabled = !!fc.retroactiveCharge.enabled;
        }
        if (fc.applessPayment) {
          this.featureConfig.applessPayment.enabled = !!fc.applessPayment.enabled;
        }
        if (fc.multiTierPricing) {
          this.featureConfig.multiTierPricing.enabled = !!fc.multiTierPricing.enabled;
          this.featureConfig.multiTierPricing.slowDisconnectPenaltyEnabled =
            !!fc.multiTierPricing.slowDisconnectPenaltyEnabled;
        }
      }
    } finally {
      this.loaded = true;
    }
  },
  methods: {
    async save() {
      this.saving = true;
      this.successMessage = "";
      this.errorMessage = "";
      try {
        await coreApiClient.call("setting", "update", undefined, {
          data: {
            featureConfig: this.featureConfig,
          },
        });
        this.$store.commit("setFeatureConfig", this.featureConfig);
        this.successMessage = "Feature configuration saved successfully";
      } catch (e) {
        this.errorMessage = "Failed to save feature configuration";
      } finally {
        this.saving = false;
      }
    },
  },
});
